import { Component, ViewEncapsulation } from '@angular/core';
import { DumbPublicMemberLocation } from '../DTOs/dumb-public-member-location';

@Component({
  selector: 'app-view-member-locations-modal',
  templateUrl: './view-member-locations-modal.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ViewMemberLocationsModalComponent {
  locations: DumbPublicMemberLocation[];
  memberName: string;
  locationClickedId: number = null;


}
